export enum FormStatusTokens {
  first = '1',
  second = '2',
  third = '3',
}
